<h3 class="marine-insurance-shipment-details-hint">
  {{ "PLEASE_FILL_OUT_THE_FOLLOWING_INFORMATION_TO_GET_YOUR_INSURANCE_QUOTE" | translate }}
</h3>

<section>
  <div class="row">
    <div class="col-12" [ngClass]="{ 'col-xl-6': !isAirTransportation }">
      <app-control-wrapper [control]="formGroup.get('transportationMode')" [errors]="defaultErrors">
        <label for="transportationMode" control-label>{{ "TRANSPORTATION" | translate }}</label>
        <ng-select
          id="transportationMode"
          class="custom"
          control-wrapper
          bindLabel="label"
          bindValue="id"
          [formControl]="formGroup.get('transportationMode')"
          [placeholder]="'FORM_PLACEHOLDER.SELECT' | translate"
          [items]="insuranceShipmentTypes"
          [clearable]="false"
        ></ng-select>
      </app-control-wrapper>
    </div>

    <div class="col-12 col-xl-6" *ngIf="!isAirTransportation">
      <app-control-wrapper
        [control]="formGroup.get(['insuredValue', 'typeOfShipment'])"
        [errors]="defaultErrors"
        *ngIf="!isAirTransportation"
      >
        <label for="typeOfShipment" control-label>{{ "PACKING_TYPE" | translate }}</label>
        <ng-select
          id="typeOfShipment"
          class="custom"
          control-wrapper
          bindLabel="label"
          bindValue="id"
          [formControl]="formGroup.get(['insuredValue', 'typeOfShipment'])"
          [placeholder]="'FORM_PLACEHOLDER.SELECT' | translate"
          [items]="insurancePackingTypes"
          [clearable]="false"
        ></ng-select>
      </app-control-wrapper>
    </div>

    <div class="col-12 col-xl-6">
      <app-control-wrapper [control]="formGroup.get(['billNumber', 'carrier'])" [errors]="defaultErrors">
        <label for="billCarrier" control-label>{{ blCarrierLabel | translate }}</label>
        <input
          type="text"
          [formControl]="formGroup.get(['billNumber', 'carrier'])"
          class="form-control"
          id="billCarrier"
          name="billCarrier"
          [placeholder]="'FORM_PLACEHOLDER.CARRIER_CODE' | translate"
          [appMaskErrorTooltip]="blCarrierMaskTooltip"
          [mask]="blCarrierMask"
          [maxMaskLength]="blCarrierMaxMaskLength"
          control-wrapper
        />
      </app-control-wrapper>
    </div>

    <div class="col-12 col-xl-6">
      <app-control-wrapper [control]="formGroup.get(['billNumber', 'number'])" [errors]="defaultErrors">
        <label for="billCarrier" control-label>{{ blNumberLabel | translate }}</label>
        <input
          type="text"
          [formControl]="formGroup.get(['billNumber', 'number'])"
          class="form-control"
          id="billNumber"
          name="billNumber"
          [placeholder]="'FORM_PLACEHOLDER.BILL_NUMBER' | translate"
          [appMaskErrorTooltip]="blNumberMaskTooltip"
          [mask]="blNumberMask"
          [maxMaskLength]="blNumberMaxMaskLength"
          control-wrapper
        />
      </app-control-wrapper>
    </div>

    <div class="col-12">
      <div class="marine-insurance-shipment-details-line"></div>
      <div class="marine-insurance-shipment-details-label">{{ "LABELS.FROM" | translate }}</div>
    </div>

    <div class="col-12 col-xl-6">
      <app-control-wrapper [control]="formGroup.get('originCity')" [errors]="defaultErrors">
        <label for="originCity" control-label>{{ "LABELS.CITY" | translate }}</label>
        <input
          class="form-control"
          id="originCity"
          name="originCity"
          type="text"
          control-wrapper
          [formControl]="formGroup.get('originCity')"
          [dropSpecialCharacters]="false"
          [patterns]="CUSTOM_MASK"
          [mask]="'F*'"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
        />
      </app-control-wrapper>
    </div>

    <div class="col-12 col-xl-6">
      <country-dropdown
        [fc]="formGroup.get('originCountry')"
        [fcValue]="formGroup.get('originCountry')?.value"
        [errors]="defaultErrors"
        [isShowRequired]="false"
        [isDesktop]="true"
        [isFilterRestrictedCountries]="true"
        [isClearable]="false"
        [isFilterOnlyMarineInsurance]="true"
      ></country-dropdown>
    </div>

    <div class="col-12">
      <div class="marine-insurance-shipment-details-line"></div>
      <div class="marine-insurance-shipment-details-label">{{ "LABELS.TO" | translate }}</div>
    </div>

    <div class="col-12 col-xl-6">
      <app-control-wrapper [control]="formGroup.get('destinationCity')" [errors]="defaultErrors">
        <label for="destinationCity" control-label>{{ "LABELS.CITY" | translate }}</label>
        <input
          class="form-control"
          id="destinationCity"
          name="destinationCity"
          type="text"
          control-wrapper
          [formControl]="formGroup.get('destinationCity')"
          [dropSpecialCharacters]="false"
          [patterns]="CUSTOM_MASK"
          [mask]="'F*'"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
        />
      </app-control-wrapper>
    </div>

    <div class="col-12 col-xl-6">
      <state-dropdown
        [countryFc]="formGroup.get('destinationCountry')"
        [stateFc]="formGroup.get('destinationState')"
        [label]="'US_STATE'"
        [isClearable]="false"
      ></state-dropdown>
    </div>

    <div class="col-12">
      <div class="marine-insurance-shipment-details-line"></div>
    </div>

    <div class="col-12">
      <date-picker
        id="shippingDate"
        placeholder="LABELS.ETD"
        name="shippingDate"
        label="LABELS.ETD"
        [fc]="formGroup.get('shippingDate')"
      ></date-picker>
    </div>

    <div class="col-12">
      <div class="marine-insurance-shipment-details-line"></div>
    </div>

    <div class="col-12" *ngIf="!isAirTransportation">
      <app-control-wrapper [control]="formGroup.get('vesselName')" [errors]="defaultErrors">
        <label for="vesselName" control-label>{{ "LABELS.VESSEL_NAME" | translate }}</label>
        <input
          class="form-control"
          id="vesselName"
          name="vesselName"
          type="text"
          maxlength="20"
          control-wrapper
          [formControl]="formGroup.get('vesselName')"
          [dropSpecialCharacters]="false"
          [patterns]="CUSTOM_MASK"
          [mask]="'F*'"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
        />
      </app-control-wrapper>
    </div>

    <div class="col-12">
      <app-control-wrapper [control]="formGroup.get('voyageNumber')" [errors]="defaultErrors">
        <label for="voyageNumber" control-label>{{ voyageNumberLabel | translate }}</label>
        <input
          class="form-control"
          id="voyageNumber"
          name="voyageNumber"
          type="text"
          maxlength="5"
          control-wrapper
          [formControl]="formGroup.get('voyageNumber')"
          [dropSpecialCharacters]="false"
          [patterns]="CUSTOM_MASK"
          [mask]="'F*'"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
        />
      </app-control-wrapper>
    </div>
  </div>
</section>

<section class="marine-insurance-shipment-details-footer">
  <button type="submit" class="btn btn-primary" [disabled]="isSaving" (click)="onSave()">
    {{ "BUTTON.SAVE" | translate }}
  </button>
</section>

<loading-spinner [show]="isSaving"></loading-spinner>
